import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { cloneDeep, get, set } from 'lodash';
import React, { FC, useState } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { FORM_FIELDS_TYPES } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { enumT, getOptionsFromRes, isObjectEmpty } from '../../../../../utils/helper';

// import schemas
import AntragsSchema from '../../../../../lib/paths/antrag_FULL_Paths.json';
const P = AntragsSchema.attributes;

const AntragMitCallsBeantragen: FC<{
	antragsDetails: any;
	foerderProgrammID: number;
	foerderProgrammDetails: any;
	allAvailablecalls: any[];
	handleCreateApplicationWithCall: (
		foerderProgrammID: number,
		foerderProgrammDetails: any,
		antragDetailsObject: any,
		callForProposalId: number
	) => void;
	show: boolean;
	onClose: () => void;
}> = ({ antragsDetails, foerderProgrammID, foerderProgrammDetails, allAvailablecalls, handleCreateApplicationWithCall, show, onClose }) => {
	const antragsformular = get(antragsDetails, 'Antragsformular', '');
	const [formValues, setFormValues] = useState<any>({});

	const handleClose = () => {
		setFormValues({});
		onClose();
	};
	const formStruc: FormStrucItem[] = [
		{
			fields: [
				{
					path: P.Call_For_Proposal.path,
					label: 'Förderaufruf',
					type: FORM_FIELDS_TYPES.singleSelect,
					options: getOptionsFromRes(allAvailablecalls, 'Allgemein_Bezeichnung'),
				},
			],
			userProps: { columnToDivide: 1 },
		},
	];

	return (
		<>
			<Dialog open={show}>
				<DialogTitle>Antrag für {enumT(antragsformular)} beantragen</DialogTitle>
				<DialogContent>
					<Typography>
						Es befinden sich verschiedene Antragsformulare in diesem Förderprogramm. Bitte wählen Sie das für Ihr Projekt passende
						Antragsformular aus.
					</Typography>

					<CreateForm
						formStruc={formStruc}
						formValues={formValues}
						updateFormValuesFunc={(path: string, value: any) => {
							let formValuesCopy = cloneDeep(formValues);
							set(formValuesCopy, path, value);
							setFormValues(formValuesCopy);
						}}
					/>
				</DialogContent>
				<DialogActions>
					<Button variant='outlined' onClick={handleClose}>
						Abbrechen
					</Button>
					<Button
						onClick={() => {
							handleCreateApplicationWithCall(
								foerderProgrammID,
								foerderProgrammDetails,
								antragsDetails,
								get(formValues, P.Call_For_Proposal.path, -1)
							);
						}}
						disabled={isObjectEmpty(formValues)}
					>
						Antrag erstellen
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default AntragMitCallsBeantragen;
